<template>
  <div class="studentMessageHome">
    <div class="navBox">
      <ul class="navRight">
        <!-- <li 
                  v-show="item.isShow!==0"
                  v-for="(item,index) in navRight"
                  :key="index"
                  @click="goPage(item.path,item.idx)"
                  :class="isActive == index?'isActive':''"
                >
                {{item.name}}
                </li> -->
        <router-link          
          v-for="(item, index) in navRight"
          :key="index"
          tag="li"
          :to="{
            path: infor.version == '2' ? item.path : item.path1,
          }"
        >
          <!-- query:{
                          username:infor.version=='2.1'?infor.username:'',
                          agentHighSchoolId:infor.version=='2.1'?infor.agentHighSchoolId:'',
                        } -->
          {{ item.name }}
        </router-link>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "mineHome",
  components: {},
  data() {
    return {
      navRight: [
        {
          name: "成绩记录",
          idx: "0",
          path: "/studyPlan/studentMessage/grade",
          isShow: 2,
          path1: "/studyPlan/studentMessage/grade",
        },
        {
          name: "竞赛信息",
          idx: "1",
          path: "/studyPlan/studentMessage/competition",
          isShow: 2,
          path1: "/studyPlan/studentMessage/competition",
        },
        {
          name: "综合素质",
          idx: "2",
          path: "/studyPlan/studentMessage/quality",
          isShow: 2,
          path1: "/studyPlan/studentMessage/quality",
        },
        {
          name: "普查信息",
          idx: "3",
          path: "/studyPlan/studentMessage/student",
          isShow: 2,
          path1: "/studyPlan/studentMessage/student",
        },
        {
          name: "家长问卷",
          idx: "4",
          path: "/studyPlan/studentMessage/parent",
          isShow: 2,
          path1: "/studyPlan/studentMessage/parent",
        },

        {
          name: "生涯报告",
          idx: "5",
          path: "/studyPlan/studentMessage/report",
          isShow: 2,
          path1: "/studyPlan/studentMessage/report",
        },
        {
          name: "生涯解读",
          idx: "6",
          path: "/studyPlan/studentMessage/reportInterpretation",
          isShow: 2,
          path1: "/studyPlan/studentMessage/reportInterpretation",
        },
      ],
      navRight1: [
        {
          name: "成绩记录",
          idx: "0",
          path: "/studyPlan/studentMessage/grade",
          isShow: 2,
          path1: "/studyPlan/studentMessage/grade",
        },
        {
          name: "竞赛信息",
          idx: "1",
          path: "/studyPlan/studentMessage/competition",
          isShow: 2,
          path1: "/studyPlan/studentMessage/competition",
        },
        {
          name: "综合素质",
          idx: "2",
          path: "/studyPlan/studentMessage/quality",
          isShow: 2,
          path1: "/studyPlan/studentMessage/quality",
        },
        {
          name: "普查信息",
          idx: "3",
          path: "/studyPlan/studentMessage/student",
          isShow: 2,
          path1: "/studyPlan/studentMessage/student",
        },
        {
          name: "家长问卷",
          idx: "4",
          path: "/studyPlan/studentMessage/parent",
          isShow: 2,
          path1: "/studyPlan/studentMessage/parent",
        },

        {
          name: "生涯报告",
          idx: "5",
          path: "/studyPlan/studentMessage/report",
          isShow: 2,
          path1: "/studyPlan/studentMessage/report",
        },
        {
          name: "生涯解读",
          idx: "6",
          path: "/studyPlan/studentMessage/reportInterpretation",
          isShow: 2,
          path1: "/studyPlan/studentMessage/reportInterpretation",
        },
        {
          name: "学习力报告",
          idx: "7",
          path: "/studyPlan/studentMessage/reportLearning/learningReport2",
          isShow: 0,
          path1:
            "/studyPlan/studentMessage/reportLearning/learningReport3",
        },
        {
          name: "学习力解读",
          idx: "8",
          path: "/studyPlan/studentMessage/reportLearning/learningReportunscramble",
          isShow: 0,
          path1:
            "/studyPlan/studentMessage/reportLearning/learningReportunscramble3",
        },

      ],
      isActive: "0",
      infor: {},
    };
  },
  created() {
    this.getReportId();
  },
  methods: {
    getReportId() {
      this.$ajax
        .post(
          this.G_acapi +
            this.ports.student.student.studentMessage.careerReport
              .getCareerReportIdByStudentIdByStudent,
          {},
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          // 生涯测评如果是1和0就不展示学习力
          if (res.data.data.career.version === 2) {
            // console.log(res.data.data.career.version)
            this.navRight = this.navRight1
            this.infor = res.data.data.learningCapacity;
            window.sessionStorage.setItem(
              "learningCapacityUser",
              this.infor.username
            );
            window.sessionStorage.setItem(
              "learningCapacitySchool",
              this.infor.agentHighSchoolId
            );
            this.navRight[7].isShow = res.data.data.learningCapacity.version; // 获取版本
            this.navRight[8].isShow = res.data.data.learningCapacity.version; // 获取版本
          }else{
            this.navRight = this.navRight
          }
        });
    },
    // goPage(path,idx){
    //     this.isActive = idx;
    //     if(this.navRight[7].isShow=='2.1'&&this.navRight[8].isShow=='2.1'){

    //     }else{
    //      this.$router.push(path)
    //     }
    // }
  },
};
</script>
<style scoped lang="less">
.studentMessageHome {
  .navBox {
    background-color: #fff;
    padding: 10px 15px 24px 15px;

    .navRight {
      padding: 0 25px;
      height: 55px;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      li {
        box-sizing: border-box;
        height: 54px;
        line-height: 54px;
        font-size: 17px;
        font-weight: 500;
        cursor: pointer;
      }

      .router-link-active {
        border-bottom: 2px solid #3d90f6;
        color: #3d90f6;
      }
    }
  }
}
</style>